import {
  ProductQuantityShell,
  WastageSwitch,
} from '@veranda/shared/components/pages/product-details';

interface ProductQuantityComponentProps {
  productType: 'TILE' | string;
  squareMetersPerBox: number | null;
  className?: string;
  isStatic?: boolean;
}

function StaticWastageSwitch() {
  return (
    <WastageSwitch>
      <WastageSwitch.Label className="font-bold text-brand-burgundy text-sm">
        <span className="max-sm:hidden">Please</span> add 15% wastage
      </WastageSwitch.Label>
      <div className="relative h-7 w-12 cursor-pointer rounded-full bg-gray-200 transition-colors focus:outline-none focus:ring-2 focus:ring-primary-bg focus:ring-offset-2 data-[state=checked]:bg-brand-burgundy">
        <div className="block size-6 translate-x-0.5 rounded-full bg-white shadow-lg transition-transform duration-100 will-change-transform data-[state=checked]:translate-x-[22px]" />
      </div>
    </WastageSwitch>
  );
}

export function ProductQuantityComponent({
  productType,
  squareMetersPerBox,
  className = 'col-span-full',
  isStatic = false,
}: ProductQuantityComponentProps) {
  const isTile = productType === 'TILE';

  return (
    <ProductQuantityShell
      productType={productType}
      squareMetersPerBox={squareMetersPerBox}
      isStatic={isStatic}
      className={className}
      quantityInputClassName="flex w-full select-none items-center border border-primary/20 px-4 py-[14px] text-primary max-md:text-sm"
      hintClassName="mt-0.5 text-primary text-xs"
      wastageSwitch={isTile ? <StaticWastageSwitch /> : undefined}
    />
  );
}
